define('lib/Podio.UI.Closable',['require','jquery','lib/Podio.Transport','models/Podio.Models.User','lib/Podio.Event.UI','lib/Podio.Routes'],function(require) {

  var $ = require('jquery');
  var transport = require('lib/Podio.Transport');
  var User = require('models/Podio.Models.User');
  var user = new User();
  var eventUI = require('lib/Podio.Event.UI');
  var routes = require('lib/Podio.Routes');

  function onClosesClicked(elmTarget, e) {
    var elmCloses = $(elmTarget.data('closes'));
    var propertyKey = elmTarget.data('property-key');
    var promotionId = elmTarget.data('promotion-id');
    var promise;

    if (propertyKey) {
      promise = user.setProperty(propertyKey, true);
    } else if (promotionId) {
      promise = transport.deleteJSON(routes.promotion_path(promotionId));
    }

    promise.done(afterClosed.curry(elmCloses));
  }

  function afterClosed(elmCloses) {
    elmCloses.fadeOut().addClass('closed');
  }

  eventUI.bind('click', '*[data-closes]', onClosesClicked);
});

